import * as actionTypes from './application.actions.types';
import { ProviderInfo, RecoverAccount, UserInfo } from './application.types';

export const login = (token: string, userInfo: UserInfo): actionTypes.SetAuthData => {
  return {
    payload: { token, userInfo },
    type: actionTypes.SET_AUTH_DATA,
  };
};

export const logout = (): actionTypes.Logout => {
  return {
    payload: {},
    type: actionTypes.LOGOUT,
  };
};

export const setProviderInfo = (providerInfo: ProviderInfo): actionTypes.SetProviderInfo => {
  return {
    payload: providerInfo,
    type: actionTypes.SET_PROVIDER_INFO,
  };
};

export const setAuthLoading = (isLoading: boolean): actionTypes.SetAuthLoading => {
  return {
    payload: { isLoading },
    type: actionTypes.SET_AUTH_LOADING,
  };
};

export const initializeAuth = (): actionTypes.InitializeAuth => {
  return {
    payload: {},
    type: actionTypes.INITIALIZE_AUTH,
  };
};

export const setProviders = (providers: ProviderInfo[]): actionTypes.SetProviders => {
  return {
    payload: { providers },
    type: actionTypes.SET_PROVIDERS,
  };
};

export const setRecoverAccount = (
  recoverAccount: RecoverAccount
): actionTypes.SetRecoverAccount => {
  return {
    payload: recoverAccount,
    type: actionTypes.SET_RECOVER_ACCOUNT,
  };
};

export const resetRecoverAccount = (): actionTypes.SetRecoverAccountInitialState => {
  return {
    payload: {},
    type: actionTypes.SET_RECOVER_ACCOUNT_INITIAL_STATE,
  };
};
